import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Compose: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1102 3.89012C19.5161 3.29618 18.7401 3 17.9621 3C17.1845 3 16.4081 3.29618 15.8141 3.89012L5.07388 14.6291L4 20L9.36996 18.9262L20.1102 8.18591C21.2966 6.99933 21.2966 5.07644 20.1102 3.89012Z"
      fill="currentColor"
    />
  </svg>
);
